import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "successMessage", "phoneInput"]
  static MODAL_CLOSE_DELAY_MS = 500

  connect() {
    // Listen for custom event to open modal
    window.addEventListener('open-lead-modal', this.handleOpenModal.bind(this))

    // Add phone formatting on input
    if (this.hasPhoneInputTarget) {
      this.phoneInputTarget.addEventListener('input', this.formatPhoneNumber.bind(this))
    }
  }

  formatPhoneNumber(event) {
    let value = event.target.value.replace(/\D/g, '') // Remove non-digits

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.substring(0, 10)
    }

    // Format as XX XX XX XX XX
    if (value.length > 0) {
      const formatted = value.match(/.{1,2}/g)?.join(' ') || value
      event.target.value = formatted
    }
  }

  disconnect() {
    window.removeEventListener('open-lead-modal', this.handleOpenModal.bind(this))
  }

  handleOpenModal(event) {
    const action = event.detail?.action

    // Store action type for later use
    this.currentAction = action

    // Update form based on action
    if (action === 'export_simulation') {
      this.formTarget.action = '/simulation_exports'
      this.updateFormForExport()
    }

    this.open()
  }

  updateFormForExport() {
    // Get simulation data from localStorage
    const simulationData = localStorage.getItem('pendingSimulationExport')

    // Add hidden field for simulation data if it doesn't exist
    let hiddenField = this.formTarget.querySelector('input[name="simulation_data"]')
    if (!hiddenField) {
      hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'simulation_data'
      this.formTarget.appendChild(hiddenField)
    }
    hiddenField.value = simulationData
  }

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  submitForm(event) {
    event.preventDefault()
    const form = this.formTarget
    const formData = new FormData(form)

    fetch(form.action, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Accept": "text/vnd.turbo-stream.html"
      }
    })
    .then(async (response) => {
      const html = await response.text()

      // Erreur serveur (ex: 422 validation) : fermer le modal puis afficher le toast d'erreur
      // rendu par le serveur (sinon il reste masqué derrière le modal). Pas de redirection
      // (évite une fausse conversion Google Ads).
      if (!response.ok) {
        this.close()
        Turbo.renderStreamMessage(html)
        return
      }

      // Succès export de simulation : rediriger vers la page de remerciement (tracking conversion Google Ads).
      if (this.currentAction === 'export_simulation') {
        window.location.href = "/merci-simulation"
        return
      }

      // Succès autre lead : afficher le toast de succès puis fermer le modal.
      Turbo.renderStreamMessage(html)

      // Close modal after a short delay
      setTimeout(() => {
        this.close()
        // Reset form for next use
        this.formTarget.reset()
      }, this.constructor.MODAL_CLOSE_DELAY_MS)
    })
    .catch(error => {
      console.error("Error submitting lead form:", error)
    })
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }
}